import { useHistory } from 'react-router-dom';
import CardComponent from '../CardComponent';
import { useFeatureFlag } from '@/context/FeatureFlagContext';

export const InvoicePayCard = () => {
    const history = useHistory();
    const isAuthenticatedInvoicePayAvailable = useFeatureFlag("AUTHENTICATED_INVOICE_PAY");

    const title = isAuthenticatedInvoicePayAvailable ? "View and pay invoices" : "Pay an invoice";
    const path = isAuthenticatedInvoicePayAvailable ? "/your-account/invoices-and-payments" : "/invoice/pay";
    const buttonLabel = isAuthenticatedInvoicePayAvailable ? "View invoices" : "Pay now";
    
    return (
        <CardComponent
            title={title}
            actions={[
                {   label: buttonLabel,
                    onClick: () => {history.push(path) },
                    sx: { fontSize: '16px', fontWeight: '700', fontFamily: 'Aeonik', lineHeight: '24px'},
                    buttonType: "mds-outline"
                }]}
            sx={{
                width: '345px',
            }}
        />
    );
};
